export const getOccupancyTypeParam = occupancyType => {
  if(occupancyType === 'Primary')
    return 'PrimaryResidence';
  if(occupancyType === 'Secondary')
    return 'SecondHome';
  if(occupancyType === 'Rental')
    return 'InvestmentProperty';
  
  return null;
}
